import { render } from "./outCodeSetting.vue?vue&type=template&id=4621e2f0"
import script from "./outCodeSetting.vue?vue&type=script&lang=js"
export * from "./outCodeSetting.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__